import React from 'react';
import '../style/shop.css';
import Copyright from '../Components/Copyrights/Copyright';
import Topbar from '../Components/Topbar/Topbar';
import MiddleBar from '../Components/MiddleBar/MiddleBar';
import Navbar from '../Components/Navbar/nav';
import Footer from '../Components/Footer/Footer';
import Newsletter from '../Components/NewsLetter/Newletter';
import Breadcrumbs from '../Components/banner/New-banner';

import ShoppingCart from '../Components/Shoppingcart/Shopping'
const ShoppingCartpage = () => {
 
  return (
    <>
      <Topbar />
      <MiddleBar />
      <Navbar />
      <Breadcrumbs/>
      <ShoppingCart/>

      <Newsletter />
      <Footer />
      <Copyright />
    </>
  );
};

export default ShoppingCartpage;
